import { Helmet } from "react-helmet-async";
import { Link, useSearchParams } from "react-router-dom";
import { useAppState } from "../context/AppContext";
import { usePractice } from "../usePractice";
import { getBrand } from "../utils/brand";
import { CasesList } from "../components/CasesList";
import { DraftsList } from "../components/DraftsList";
import { useState, useEffect } from "react";

function PracticeHome() {
  const { state } = useAppState();
  const userId = state.user?.uid;
  const { practice, isLoadingPractice } = usePractice();
  const practiceFields = practice?.fields;
  const brand = getBrand(practiceFields?.brand);
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(
    tabParam === "drafts" ? "drafts" : "cases"
  );

  // Sync tab with URL param
  useEffect(() => {
    if (tabParam === "drafts" || tabParam === "cases") {
      setActiveTab(tabParam);
    }
  }, [tabParam]);

  // When tab changes, update URL param
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  return (
    <div className="container">
      <Helmet>
        <title>{brand.name} - Practice Dashboard</title>
      </Helmet>

      <div className="container-inner">
        {practiceFields ? (
          <>
            <div className="cases-header flex items-center justify-between mb-3">
              <h2>Cases</h2>
              <div className="links">
                <Link
                  className="button spaced"
                  to={`/${practiceFields.slug}/new-case`}
                  data-cy="new-case-button"
                >
                  New Case
                </Link>

                <Link
                  className="button spaced button-yellow-900"
                  to={"https://evviaftercare.notion.site"}
                >
                  Evvi Wiki
                </Link>
              </div>
            </div>

            <div className="tabs mb-4">
              <button
                className={`tab ${activeTab === "drafts" ? "active" : ""}`}
                onClick={() => handleTabChange("drafts")}
                data-cy="tab-drafts"
              >
                Drafts
              </button>
              <button
                className={`tab ${activeTab === "cases" ? "active" : ""}`}
                onClick={() => handleTabChange("cases")}
                data-cy="tab-cases"
              >
                Submitted
              </button>
            </div>

            {/* Tab content */}
            {activeTab === "drafts" && (
              <DraftsList userId={userId} practice={practice} />
            )}
            {activeTab === "cases" && practiceFields.slug && state?.user && (
              <CasesList practiceSlug={practiceFields.slug} />
            )}
          </>
        ) : isLoadingPractice ? (
          <div className="loading-screen regular-2xl">Loading...</div>
        ) : (
          <p className="input-error">
            Could not load this practice. Please refresh and try again.
          </p>
        )}
      </div>
    </div>
  );
}

export default PracticeHome;
